import leadModalTabs from './tabs';

const texts = {
  tabLabels: {
    [leadModalTabs.LEAD_DETAILS]: 'Lead Details',
    [leadModalTabs.CONTRACT]: 'Contract',
    [leadModalTabs.COACH_DETAILS]: 'Coach Details',
    [leadModalTabs.PROMOTIONS]: 'Promos',
    [leadModalTabs.CHAT]: 'Chat',
    [leadModalTabs.HISTORY]: 'History',
  },
  outcomeNotRecorded: 'Please record the outcome before closing the lead modal',
  errorFetchingPromotions: 'Error fetching promotions: {error}',
  followUpScheduledAt: 'Follow-Up - Scheduled for {followUpDateText}',
  bookACall: 'Book a Call',
  markAsLost: 'Mark as Lost',
  somethingWentWrong: 'Something went wrong',
  leadWonRecorded: 'This lead has been marked as won. Please record the outcome before closing.',
  leadPaymentPendingRecorded:
    'This lead will complete payment in the future. '
    + 'Please record the outcome before closing.',
  coachLabel: 'Coach:',
};

export default texts;
